module.exports = __webpack_public_path__ + "static/media/wavm8s-003-citytronix.8680747.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-003-citytronix.mp3
// module id = luLe
// module chunks = 0